module.exports = __webpack_public_path__ + "static/img/mamanvogue-01.81e4778.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamanvogue-01.webp
// module id = 112
// module chunks = 0